<template>
	<div>
		<sky-upload ref="upload" :value="value" v-bind="$attrs" v-on="$listeners">
			<slot
				name="filePopperContent"
				slot="filePopperContent"
				slot-scope="scope"
				:file="scope.file"
			></slot>
		</sky-upload>
		<div class="notice">{{ notice }}</div>
	</div>
</template>
<script>
import skyUpload from 'sky-upload';
export default {
	name: 'sky-uploadimg',
	props: {
		value: {
			requiry: true,
		},
		notice: {
			type: String,
			default: '',
		},
	},
	data() {
		return {};
	},

	methods: {},
	components: { skyUpload },
};
</script>

<style scoped lang="scss">
.notice {
	font-size: 12px;
	line-height: 20px;
}
</style>
